'use client';

import { noop, safeRequest } from '@capsicum/common';
import { useEffect, useState } from 'react';

import { postValidationEmail } from '../data-access/api/register';
import { type WelcomeVariant } from '../models/welcome';
import { type WelcomeFormattedMedium } from '../models/welcomeFormattedMedium';

type UsePhoneNumberVerificationCheckerProps = {
	formattedValues: WelcomeFormattedMedium;
	onError?: (error: unknown) => void;
	variant: WelcomeVariant;
};

export const usePhoneNumberVerificationChecker = ({
	formattedValues,
	onError = noop,
	variant
}: UsePhoneNumberVerificationCheckerProps) => {
	const [isVerified, setVerified] = useState(false);

	useEffect(() => {
		if (variant !== 'login') {
			setVerified(false);

			return;
		}

		if (formattedValues.type === 'phone-number') {
			setVerified(true);

			return;
		}

		safeRequest(() => postValidationEmail({ email: formattedValues.medium.email }))
			.then(({ data, error }) => {
				if (error) {
					onError(error);
					setVerified(false);

					return;
				}

				setVerified(data?.hasMobileNumber ?? false);
			})
			.catch(onError);
	}, [onError, variant, formattedValues.type, formattedValues.medium.email]);

	return isVerified;
};
